import { Skeleton } from '@mui/material';

export const AcheivementCardLoading = () => {
  return <Skeleton sx={{ borderRadius: 1, bgcolor: 'lolCard.secondary' }} height={90} />;
};
